// extracted by mini-css-extract-plugin
module.exports = {"custom-zalo-widget":"zaloChatWidget_custom-zalo-widget____q_n"};